//
//
//
//
//
//
//
//
//

import ConfigOption from './ConfigOption.vue'
export default {
  name: 'ConfigGroup',
  components: {'config-option': ConfigOption},
  props: ['item'],
  methods: {
    handleChoiceUpdate(payload) {
      this.$emit('updatedChoice', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/vue/partials/ConfigGroup.vue